// client/ui/help/HelpTip.tsx
// Tooltip wrapper that uses helpId to show contextual help

import { Tooltip, TooltipContent, TooltipTrigger } from "../../components/ui/tooltip";
import { useHelpText } from "../../state/HelpOverridesProvider";
import { HELP_TEXT, type HelpKey } from "./helptext.en-US";
import * as React from "react";

type HelpTipProps = {
  helpId: HelpKey;
  children: React.ReactElement;
  asChild?: boolean;
  side?: "top" | "right" | "bottom" | "left";
};

export function HelpTip({ helpId, children, asChild = true, side = "top" }: HelpTipProps) {
  const { resolve } = useHelpText();
  const defaultText = HELP_TEXT[helpId] ?? "";
  const text = resolve(helpId, defaultText);

  // Ensure the trigger has a stable test hook
  const childWithAttr = React.isValidElement(children)
    ? React.cloneElement(children, { ...(children.props || {}), ["data-helpid"]: helpId } as React.Attributes & { "data-helpid": string })
    : children;

  return (
    <Tooltip>
      <TooltipTrigger asChild={asChild} aria-describedby={`help-${helpId}`}>
        {childWithAttr}
      </TooltipTrigger>
      <TooltipContent id={`help-${helpId}`} side={side} className="max-w-[320px] leading-snug">
        <p>{text}</p>
      </TooltipContent>
    </Tooltip>
  );
}
